import clsx from 'clsx';
import { FC, HTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.css';

interface ISpan extends HTMLAttributes<HTMLSpanElement> {
  fontSize?: 12 | 14;
}

export const Span = forwardRef<HTMLSpanElement | null, ISpan>((props, ref) => (
  <span ref={ref} {...props} />
));

export const P: FC<HTMLAttributes<HTMLParagraphElement>> = (props) => (
  <p {...props} className={clsx(styles.p, props.className)} />
);

export const H1: FC<HTMLAttributes<HTMLHeadingElement>> = (props) => (
  <h1 {...props} className={clsx(styles.h1, props.className)} />
);

export const H2: FC<HTMLAttributes<HTMLHeadingElement>> = (props) => (
  <h2 {...props} className={clsx(styles.h2, props.className)} />
);

export const H3: FC<HTMLAttributes<HTMLHeadingElement>> = (props) => (
  <h3 {...props} className={clsx(styles.h3, props.className)} />
);

export const H4: FC<HTMLAttributes<HTMLHeadingElement>> = (props) => (
  <h4 {...props} className={clsx(styles.h4, props.className)} />
);
